"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "player_home_block" };
const _hoisted_3 = ["href"];
const _hoisted_4 = { key: 1 };
const _hoisted_5 = {
    id: "section-board",
    class: "player_home_block"
};
const _hoisted_6 = {
    key: 3,
    class: "player_home_block--milestones-and-awards"
};
const _hoisted_7 = {
    key: 4,
    class: "player_home_block",
    ref: "colonies",
    id: "shortkey-colonies"
};
const _hoisted_8 = { class: "colonies-fleets-cont" };
const _hoisted_9 = { class: "player_home_colony_cont" };
const _hoisted_10 = { id: "section-players" };
const _hoisted_11 = {
    id: "section-log",
    class: "player_home_block nofloat"
};
const _hoisted_12 = { id: "section-play" };
const _hoisted_13 = { class: "player_home_block player_home_block--actions nofloat" };
const _hoisted_14 = {
    key: 0,
    class: "player_home_block player_home_block--hand"
};
const _hoisted_15 = {
    key: 1,
    class: "player_home_block player_home_block--hand",
    id: "shortkey-hand"
};
const _hoisted_16 = { class: "hiding-card-button-row" };
const _hoisted_17 = { class: "played-cards-count" };
const _hoisted_18 = { class: "played-cards-selection" };
const _hoisted_19 = { class: "text-overview" };
const _hoisted_20 = {
    key: 0,
    class: "general-warning"
};
const _hoisted_21 = { class: "player_home_block player_home_block--cards" };
const _hoisted_22 = { class: "hiding-card-button-row" };
const _hoisted_23 = { class: "played-cards-filters" };
const _hoisted_24 = { class: "played-cards-count" };
const _hoisted_25 = { class: "played-cards-selection" };
const _hoisted_26 = { class: "played-cards-count" };
const _hoisted_27 = { class: "played-cards-selection" };
const _hoisted_28 = { class: "played-cards-count" };
const _hoisted_29 = { class: "played-cards-selection" };
const _hoisted_30 = { class: "text-overview" };
const _hoisted_31 = {
    key: 2,
    class: "player_home_block"
};
const _hoisted_32 = { key: 3 };
const _hoisted_33 = { class: "bottom-tab-nav" };
const _hoisted_34 = {
    key: 2,
    class: "player_home_block player_home_block--setup nofloat"
};
const _hoisted_35 = {
    key: 1,
    class: "player_home_block player_home_block--hand"
};
const _hoisted_36 = { class: "cardbox" };
const _hoisted_37 = {
    key: 5,
    class: "player_home_block"
};
const _hoisted_38 = {
    key: 6,
    class: "player_home_block player_home_block--turnorder nofloat"
};
const _hoisted_39 = { class: "player_number" };
const _hoisted_40 = {
    key: 0,
    class: "player_separator"
};
const _hoisted_41 = {
    class: "accordion board-accordion",
    open: ""
};
const _hoisted_42 = { class: "accordion-header" };
const _hoisted_43 = { class: "is-action" };
const _hoisted_44 = { class: "accordion-body" };
const _hoisted_45 = {
    key: 7,
    class: "player_home_block"
};
const _hoisted_46 = { class: "player_home_colony_cont" };
const _hoisted_47 = { key: 3 };
const _hoisted_48 = ["href"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_top_bar = (0, vue_1.resolveComponent)("top-bar");
    const _component_DynamicTitle = (0, vue_1.resolveComponent)("DynamicTitle");
    const _component_sidebar = (0, vue_1.resolveComponent)("sidebar");
    const _component_board = (0, vue_1.resolveComponent)("board");
    const _component_turmoil = (0, vue_1.resolveComponent)("turmoil");
    const _component_MoonBoard = (0, vue_1.resolveComponent)("MoonBoard");
    const _component_PlanetaryTracks = (0, vue_1.resolveComponent)("PlanetaryTracks");
    const _component_Milestones = (0, vue_1.resolveComponent)("Milestones");
    const _component_Awards = (0, vue_1.resolveComponent)("Awards");
    const _component_dynamic_title = (0, vue_1.resolveComponent)("dynamic-title");
    const _component_colony = (0, vue_1.resolveComponent)("colony");
    const _component_players_overview = (0, vue_1.resolveComponent)("players-overview");
    const _component_log_panel = (0, vue_1.resolveComponent)("log-panel");
    const _component_waiting_for = (0, vue_1.resolveComponent)("waiting-for");
    const _component_Card = (0, vue_1.resolveComponent)("Card");
    const _component_sortable_cards = (0, vue_1.resolveComponent)("sortable-cards");
    const _component_stacked_cards = (0, vue_1.resolveComponent)("stacked-cards");
    const _component_underground_tokens = (0, vue_1.resolveComponent)("underground-tokens");
    const _component_purge_warning = (0, vue_1.resolveComponent)("purge-warning");
    const _component_KeyboardShortcuts = (0, vue_1.resolveComponent)("KeyboardShortcuts");
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    const _directive_trim_whitespace = (0, vue_1.resolveDirective)("trim-whitespace");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
        id: "player-home",
        class: (0, vue_1.normalizeClass)((_ctx.game.turmoil ? 'with-turmoil' : ''))
    }, [
        (0, vue_1.createVNode)(_component_top_bar, { playerView: _ctx.playerView }, null, 8, ["playerView"]),
        (_ctx.game.phase === 'end')
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
                (0, vue_1.createElementVNode)("div", _hoisted_2, [
                    (0, vue_1.createVNode)(_component_DynamicTitle, {
                        title: "This game is over!",
                        color: _ctx.thisPlayer.color
                    }, null, 8, ["color"]),
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                        href: 'the-end?id=' + _ctx.playerView.id
                    }, [...(_cache[10] || (_cache[10] = [
                            (0, vue_1.createTextVNode)("Go to game results", -1)
                        ]))], 8, _hoisted_3)), [
                        [_directive_i18n]
                    ])
                ])
            ]))
            : (0, vue_1.createCommentVNode)("", true),
        (0, vue_1.withDirectives)((0, vue_1.createVNode)(_component_sidebar, {
            acting_player: _ctx.isPlayerActing(_ctx.playerView),
            player_color: _ctx.thisPlayer.color,
            generation: _ctx.game.generation,
            coloniesCount: _ctx.game.colonies.length,
            temperature: _ctx.game.temperature,
            oxygen: _ctx.game.oxygenLevel,
            oceans: _ctx.game.oceans,
            venus: _ctx.game.venusScaleLevel,
            turmoil: _ctx.game.turmoil,
            moonData: _ctx.game.moon,
            gameOptions: _ctx.game.gameOptions,
            playerNumber: _ctx.playerView.players.length,
            lastSoloGeneration: _ctx.game.lastSoloGeneration,
            deckSize: _ctx.game.deckSize,
            discardPileSize: _ctx.game.discardPileSize
        }, null, 8, ["acting_player", "player_color", "generation", "coloniesCount", "temperature", "oxygen", "oceans", "venus", "turmoil", "moonData", "gameOptions", "playerNumber", "lastSoloGeneration", "deckSize", "discardPileSize"]), [
            [_directive_trim_whitespace]
        ]),
        (!_ctx.isInSetupPhase)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_4, [
                (0, vue_1.createElementVNode)("div", _hoisted_5, [
                    _cache[16] || (_cache[16] = (0, vue_1.createElementVNode)("a", {
                        name: "board",
                        class: "player_home_anchor hotkey-target"
                    }, null, -1)),
                    (0, vue_1.createVNode)(_component_board, {
                        spaces: _ctx.game.spaces,
                        expansions: _ctx.game.gameOptions.expansions,
                        venusScaleLevel: _ctx.game.venusScaleLevel,
                        boardName: _ctx.game.gameOptions.boardName,
                        oceans_count: _ctx.game.oceans,
                        oxygen_level: _ctx.game.oxygenLevel,
                        temperature: _ctx.game.temperature,
                        altVenusBoard: _ctx.game.gameOptions.altVenusBoard,
                        aresData: _ctx.game.aresData,
                        tileView: _ctx.tileView,
                        onToggleTileView: _cache[0] || (_cache[0] = ($event) => (_ctx.cycleTileView())),
                        id: "shortkey-board"
                    }, null, 8, ["spaces", "expansions", "venusScaleLevel", "boardName", "oceans_count", "oxygen_level", "temperature", "altVenusBoard", "aresData", "tileView"]),
                    (_ctx.game.turmoil)
                        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 0 }, [
                            _cache[11] || (_cache[11] = (0, vue_1.createElementVNode)("a", { class: "hotkey-target" }, null, -1)),
                            (0, vue_1.createVNode)(_component_turmoil, {
                                turmoil: _ctx.game.turmoil
                            }, null, 8, ["turmoil"])
                        ], 64))
                        : (0, vue_1.createCommentVNode)("", true),
                    (_ctx.game.moon)
                        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 1 }, [
                            _cache[12] || (_cache[12] = (0, vue_1.createElementVNode)("a", { class: "hotkey-target" }, null, -1)),
                            (0, vue_1.createVNode)(_component_MoonBoard, {
                                model: _ctx.game.moon,
                                tileView: _ctx.tileView,
                                id: "shortkey-moonBoard"
                            }, null, 8, ["model", "tileView"])
                        ], 64))
                        : (0, vue_1.createCommentVNode)("", true),
                    (_ctx.game.gameOptions.expansions.pathfinders)
                        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 2 }, [
                            _cache[13] || (_cache[13] = (0, vue_1.createElementVNode)("a", { class: "hotkey-target" }, null, -1)),
                            (0, vue_1.createVNode)(_component_PlanetaryTracks, {
                                tracks: _ctx.game.pathfinders,
                                gameOptions: _ctx.game.gameOptions
                            }, null, 8, ["tracks", "gameOptions"])
                        ], 64))
                        : (0, vue_1.createCommentVNode)("", true),
                    (_ctx.playerView.players.length > 1)
                        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_6, [
                            _cache[14] || (_cache[14] = (0, vue_1.createElementVNode)("a", { class: "hotkey-target" }, null, -1)),
                            (0, vue_1.createVNode)(_component_Milestones, {
                                milestones: _ctx.game.milestones
                            }, null, 8, ["milestones"]),
                            (0, vue_1.createVNode)(_component_Awards, {
                                awards: _ctx.game.awards
                            }, null, 8, ["awards"])
                        ]))
                        : (0, vue_1.createCommentVNode)("", true),
                    (_ctx.game.colonies.length > 0)
                        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_7, [
                            _cache[15] || (_cache[15] = (0, vue_1.createElementVNode)("a", {
                                name: "colonies",
                                class: "player_home_anchor hotkey-target"
                            }, null, -1)),
                            (0, vue_1.createVNode)(_component_dynamic_title, {
                                title: "Colonies",
                                color: _ctx.thisPlayer.color
                            }, null, 8, ["color"]),
                            (0, vue_1.createElementVNode)("div", _hoisted_8, [
                                ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.playerView.players, (colonyPlayer) => {
                                    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                                        class: "colonies-player-fleets",
                                        key: colonyPlayer.color
                                    }, [
                                        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.getFleetsCountRange(colonyPlayer), (idx) => {
                                            return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                                                class: (0, vue_1.normalizeClass)('colonies-fleet colonies-fleet-' + colonyPlayer.color),
                                                key: idx
                                            }, null, 2));
                                        }), 128))
                                    ]));
                                }), 128))
                            ]),
                            (0, vue_1.createElementVNode)("div", _hoisted_9, [
                                ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.game.colonies, (colony) => {
                                    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                                        class: "player_home_colony",
                                        key: colony.name
                                    }, [
                                        (0, vue_1.createVNode)(_component_colony, {
                                            colony: colony,
                                            active: colony.isActive
                                        }, null, 8, ["colony", "active"])
                                    ]));
                                }), 128))
                            ])
                        ], 512))
                        : (0, vue_1.createCommentVNode)("", true)
                ]),
                (0, vue_1.createElementVNode)("div", _hoisted_10, [
                    _cache[17] || (_cache[17] = (0, vue_1.createElementVNode)("a", { class: "hotkey-target" }, null, -1)),
                    (0, vue_1.withDirectives)((0, vue_1.createVNode)(_component_players_overview, {
                        class: "player_home_block player_home_block--players nofloat",
                        playerView: _ctx.playerView,
                        id: "shortkey-playersoverview"
                    }, null, 8, ["playerView"]), [
                        [_directive_trim_whitespace]
                    ]),
                    (0, vue_1.createElementVNode)("div", _hoisted_11, [
                        (0, vue_1.createVNode)(_component_log_panel, {
                            viewModel: _ctx.playerView,
                            color: _ctx.thisPlayer.color,
                            step: _ctx.game.step
                        }, null, 8, ["viewModel", "color", "step"])
                    ])
                ]),
                (0, vue_1.createElementVNode)("div", _hoisted_12, [
                    (0, vue_1.createElementVNode)("div", _hoisted_13, [
                        _cache[18] || (_cache[18] = (0, vue_1.createElementVNode)("a", {
                            name: "actions",
                            class: "player_home_anchor"
                        }, null, -1)),
                        (0, vue_1.createVNode)(_component_dynamic_title, {
                            title: "Actions",
                            color: _ctx.thisPlayer.color
                        }, null, 8, ["color"]),
                        (_ctx.game.phase !== 'end')
                            ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_waiting_for, {
                                key: 0,
                                players: _ctx.playerView.players,
                                playerView: _ctx.playerView,
                                settings: _ctx.settings,
                                waitingfor: _ctx.playerView.waitingFor
                            }, null, 8, ["players", "playerView", "settings", "waitingfor"]))
                            : (0, vue_1.createCommentVNode)("", true)
                    ]),
                    (_ctx.playerView.draftedCards.length > 0)
                        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_14, [
                            (0, vue_1.createVNode)(_component_dynamic_title, {
                                title: "Drafted cards",
                                color: _ctx.thisPlayer.color
                            }, null, 8, ["color"]),
                            ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.playerView.draftedCards, (card) => {
                                return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                                    key: card.name,
                                    class: "cardbox"
                                }, [
                                    (0, vue_1.createVNode)(_component_Card, { card: card }, null, 8, ["card"])
                                ]));
                            }), 128))
                        ]))
                        : (0, vue_1.createCommentVNode)("", true),
                    _cache[22] || (_cache[22] = (0, vue_1.createElementVNode)("a", {
                        name: "cards",
                        class: "player_home_anchor"
                    }, null, -1)),
                    (_ctx.cardsInHandCount > 0)
                        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_15, [
                            (0, vue_1.createElementVNode)("div", _hoisted_16, [
                                (0, vue_1.createVNode)(_component_dynamic_title, {
                                    title: "Cards In Hand",
                                    color: _ctx.thisPlayer.color
                                }, null, 8, ["color"]),
                                (0, vue_1.createElementVNode)("div", {
                                    class: (0, vue_1.normalizeClass)(_ctx.getHideButtonClass('HAND')),
                                    onClick: _cache[1] || (_cache[1] = (0, vue_1.withModifiers)(($event) => (_ctx.toggle('HAND')), ["prevent"]))
                                }, [
                                    (0, vue_1.createElementVNode)("div", _hoisted_17, (0, vue_1.toDisplayString)(_ctx.cardsInHandCount.toString()), 1),
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_18, [
                                        (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(_ctx.getToggleLabel('HAND')), 1)
                                    ])), [
                                        [_directive_i18n]
                                    ])
                                ], 2),
                                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_19, [...(_cache[19] || (_cache[19] = [
                                        (0, vue_1.createTextVNode)("[ toggle cards in hand ]", -1)
                                    ]))])), [
                                    [_directive_i18n]
                                ])
                            ]),
                            (_ctx.isVisible('HAND') && _ctx.playerView.players.length > 1 && !_ctx.isPlayerActing(_ctx.playerView))
                                ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_20, [...(_cache[20] || (_cache[20] = [
                                        (0, vue_1.createTextVNode)(" Card eligibility may be out of date until your turn begins. ", -1)
                                    ]))])), [
                                    [_directive_i18n]
                                ])
                                : (0, vue_1.createCommentVNode)("", true),
                            (0, vue_1.withDirectives)((0, vue_1.createVNode)(_component_sortable_cards, {
                                playerId: _ctx.playerView.id,
                                cards: _ctx.playerView.preludeCardsInHand
                                    .concat(_ctx.playerView.ceoCardsInHand)
                                    .concat(_ctx.playerView.cardsInHand)
                            }, null, 8, ["playerId", "cards"]), [
                                [vue_1.vShow, _ctx.isVisible('HAND')]
                            ])
                        ]))
                        : (0, vue_1.createCommentVNode)("", true),
                    (0, vue_1.createElementVNode)("div", _hoisted_21, [
                        (0, vue_1.createElementVNode)("div", _hoisted_22, [
                            (0, vue_1.createVNode)(_component_dynamic_title, {
                                title: "Played Cards",
                                color: _ctx.thisPlayer.color
                            }, null, 8, ["color"]),
                            (0, vue_1.createElementVNode)("div", _hoisted_23, [
                                (0, vue_1.createElementVNode)("div", {
                                    class: (0, vue_1.normalizeClass)(_ctx.getHideButtonClass('ACTIVE')),
                                    onClick: _cache[2] || (_cache[2] = (0, vue_1.withModifiers)(($event) => (_ctx.toggle('ACTIVE')), ["prevent"]))
                                }, [
                                    (0, vue_1.createElementVNode)("div", _hoisted_24, (0, vue_1.toDisplayString)(_ctx.getCardsByType(_ctx.thisPlayer.tableau, [_ctx.CardType.ACTIVE]).length.toString()), 1),
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_25, [
                                        (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(_ctx.getToggleLabel('ACTIVE')), 1)
                                    ])), [
                                        [_directive_i18n]
                                    ])
                                ], 2),
                                (0, vue_1.createElementVNode)("div", {
                                    class: (0, vue_1.normalizeClass)(_ctx.getHideButtonClass('AUTOMATED')),
                                    onClick: _cache[3] || (_cache[3] = (0, vue_1.withModifiers)(($event) => (_ctx.toggle('AUTOMATED')), ["prevent"]))
                                }, [
                                    (0, vue_1.createElementVNode)("div", _hoisted_26, (0, vue_1.toDisplayString)(_ctx.getCardsByType(_ctx.thisPlayer.tableau, [_ctx.CardType.AUTOMATED, _ctx.CardType.PRELUDE]).length.toString()), 1),
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_27, [
                                        (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(_ctx.getToggleLabel('AUTOMATED')), 1)
                                    ])), [
                                        [_directive_i18n]
                                    ])
                                ], 2),
                                (0, vue_1.createElementVNode)("div", {
                                    class: (0, vue_1.normalizeClass)(_ctx.getHideButtonClass('EVENT')),
                                    onClick: _cache[4] || (_cache[4] = (0, vue_1.withModifiers)(($event) => (_ctx.toggle('EVENT')), ["prevent"]))
                                }, [
                                    (0, vue_1.createElementVNode)("div", _hoisted_28, (0, vue_1.toDisplayString)(_ctx.getCardsByType(_ctx.thisPlayer.tableau, [_ctx.CardType.EVENT]).length.toString()), 1),
                                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_29, [
                                        (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(_ctx.getToggleLabel('EVENT')), 1)
                                    ])), [
                                        [_directive_i18n]
                                    ])
                                ], 2)
                            ]),
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_30, [...(_cache[21] || (_cache[21] = [
                                    (0, vue_1.createTextVNode)("[ toggle cards filters ]", -1)
                                ]))])), [
                                [_directive_i18n]
                            ])
                        ]),
                        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.getCardsByType(_ctx.thisPlayer.tableau, [_ctx.CardType.CORPORATION]), (card) => {
                            return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                                key: card.name,
                                class: "cardbox"
                            }, [
                                (0, vue_1.createVNode)(_component_Card, {
                                    card: card,
                                    actionUsed: _ctx.isCardActivated(card, _ctx.thisPlayer),
                                    cubeColor: _ctx.thisPlayer.color
                                }, null, 8, ["card", "actionUsed", "cubeColor"])
                            ]));
                        }), 128)),
                        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.getCardsByType(_ctx.thisPlayer.tableau, [_ctx.CardType.CEO]), (card) => {
                            return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                                key: card.name,
                                class: "cardbox"
                            }, [
                                (0, vue_1.createVNode)(_component_Card, {
                                    card: card,
                                    actionUsed: _ctx.isCardActivated(card, _ctx.thisPlayer),
                                    cubeColor: _ctx.thisPlayer.color
                                }, null, 8, ["card", "actionUsed", "cubeColor"])
                            ]));
                        }), 128)),
                        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.sortActiveCards(_ctx.getCardsByType(_ctx.thisPlayer.tableau, [_ctx.CardType.ACTIVE, _ctx.CardType.PRELUDE]).filter(_ctx.isActive)), (card) => {
                            return (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                                key: card.name,
                                class: "cardbox"
                            }, [
                                (0, vue_1.createVNode)(_component_Card, {
                                    card: card,
                                    actionUsed: _ctx.isCardActivated(card, _ctx.thisPlayer),
                                    cubeColor: _ctx.thisPlayer.color
                                }, null, 8, ["card", "actionUsed", "cubeColor"])
                            ])), [
                                [vue_1.vShow, _ctx.isVisible('ACTIVE')]
                            ]);
                        }), 128)),
                        (0, vue_1.withDirectives)((0, vue_1.createVNode)(_component_stacked_cards, {
                            cards: _ctx.getCardsByType(_ctx.thisPlayer.tableau, [_ctx.CardType.AUTOMATED, _ctx.CardType.PRELUDE]).filter(_ctx.isNotActive)
                        }, null, 8, ["cards"]), [
                            [vue_1.vShow, _ctx.isVisible('AUTOMATED')]
                        ]),
                        (0, vue_1.withDirectives)((0, vue_1.createVNode)(_component_stacked_cards, {
                            cards: _ctx.getCardsByType(_ctx.thisPlayer.tableau, [_ctx.CardType.EVENT])
                        }, null, 8, ["cards"]), [
                            [vue_1.vShow, _ctx.isVisible('EVENT')]
                        ])
                    ]),
                    (_ctx.thisPlayer.selfReplicatingRobotsCards.length > 0)
                        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_31, [
                            (0, vue_1.createVNode)(_component_dynamic_title, {
                                title: "Self-replicating Robots cards",
                                color: _ctx.thisPlayer.color
                            }, null, 8, ["color"]),
                            (0, vue_1.createElementVNode)("div", null, [
                                ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.thisPlayer.selfReplicatingRobotsCards, (card) => {
                                    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                                        key: card.name,
                                        class: "cardbox"
                                    }, [
                                        (0, vue_1.createVNode)(_component_Card, { card: card }, null, 8, ["card"])
                                    ]));
                                }), 128))
                            ])
                        ]))
                        : (0, vue_1.createCommentVNode)("", true),
                    (_ctx.thisPlayer.underworldData.tokens.length > 0)
                        ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_32, [
                            (0, vue_1.createVNode)(_component_dynamic_title, {
                                title: "Claimed Underground Resource Tokens",
                                color: _ctx.thisPlayer.color
                            }, null, 8, ["color"]),
                            (0, vue_1.createVNode)(_component_underground_tokens, {
                                underworldData: _ctx.thisPlayer.underworldData
                            }, null, 8, ["underworldData"])
                        ]))
                        : (0, vue_1.createCommentVNode)("", true)
                ]),
                (0, vue_1.createElementVNode)("nav", _hoisted_33, [
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("button", {
                        onClick: _cache[5] || (_cache[5] = ($event) => (_ctx.scrollTo('section-board')))
                    }, [...(_cache[23] || (_cache[23] = [
                            (0, vue_1.createTextVNode)("Board", -1)
                        ]))])), [
                        [_directive_i18n]
                    ]),
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("button", {
                        onClick: _cache[6] || (_cache[6] = ($event) => (_ctx.scrollTo('section-players')))
                    }, [...(_cache[24] || (_cache[24] = [
                            (0, vue_1.createTextVNode)("All Players", -1)
                        ]))])), [
                        [_directive_i18n]
                    ]),
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("button", {
                        onClick: _cache[7] || (_cache[7] = ($event) => (_ctx.scrollTo('section-log')))
                    }, [...(_cache[25] || (_cache[25] = [
                            (0, vue_1.createTextVNode)("Log", -1)
                        ]))])), [
                        [_directive_i18n]
                    ]),
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("button", {
                        onClick: _cache[8] || (_cache[8] = ($event) => (_ctx.scrollTo('section-play'))),
                        class: (0, vue_1.normalizeClass)({ 'needs-action': _ctx.playerView.waitingFor !== undefined })
                    }, [...(_cache[26] || (_cache[26] = [
                            (0, vue_1.createTextVNode)("Play", -1)
                        ]))], 2)), [
                        [_directive_i18n]
                    ])
                ])
            ]))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.isInSetupPhase)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_34, [
                (_ctx.isInitialDraftingPhase)
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 0 }, [
                        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.playerView.dealtCorporationCards, (card) => {
                            return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                                key: card.name,
                                class: "cardbox"
                            }, [
                                (0, vue_1.createVNode)(_component_Card, { card: card }, null, 8, ["card"])
                            ]));
                        }), 128)),
                        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.playerView.dealtPreludeCards, (card) => {
                            return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                                key: card.name,
                                class: "cardbox"
                            }, [
                                (0, vue_1.createVNode)(_component_Card, { card: card }, null, 8, ["card"])
                            ]));
                        }), 128)),
                        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.playerView.dealtCeoCards, (card) => {
                            return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                                key: card.name,
                                class: "cardbox"
                            }, [
                                (0, vue_1.createVNode)(_component_Card, { card: card }, null, 8, ["card"])
                            ]));
                        }), 128)),
                        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.playerView.dealtProjectCards, (card) => {
                            return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                                key: card.name,
                                class: "cardbox"
                            }, [
                                (0, vue_1.createVNode)(_component_Card, { card: card }, null, 8, ["card"])
                            ]));
                        }), 128))
                    ], 64))
                    : (0, vue_1.createCommentVNode)("", true),
                (_ctx.playerView.draftedCards.length > 0)
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_35, [
                        (0, vue_1.createVNode)(_component_dynamic_title, {
                            title: "Drafted Cards",
                            color: _ctx.thisPlayer.color
                        }, null, 8, ["color"]),
                        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.playerView.draftedCards, (card) => {
                            return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                                key: card.name,
                                class: "cardbox"
                            }, [
                                (0, vue_1.createVNode)(_component_Card, { card: card }, null, 8, ["card"])
                            ]));
                        }), 128))
                    ]))
                    : (0, vue_1.createCommentVNode)("", true),
                (_ctx.playerView.pickedCorporationCard.length === 1)
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 2 }, [
                        (0, vue_1.createVNode)(_component_dynamic_title, {
                            title: "Your selected cards:",
                            color: _ctx.thisPlayer.color
                        }, null, 8, ["color"]),
                        (0, vue_1.createElementVNode)("div", null, [
                            (0, vue_1.createElementVNode)("div", _hoisted_36, [
                                (0, vue_1.createVNode)(_component_Card, {
                                    card: _ctx.playerView.pickedCorporationCard[0]
                                }, null, 8, ["card"])
                            ]),
                            (_ctx.game.gameOptions.expansions.prelude)
                                ? ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 0 }, (0, vue_1.renderList)(_ctx.playerView.preludeCardsInHand, (card) => {
                                    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                                        key: card.name,
                                        class: "cardbox"
                                    }, [
                                        (0, vue_1.createVNode)(_component_Card, { card: card }, null, 8, ["card"])
                                    ]));
                                }), 128))
                                : (0, vue_1.createCommentVNode)("", true),
                            (_ctx.game.gameOptions.expansions.ceo)
                                ? ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 1 }, (0, vue_1.renderList)(_ctx.playerView.ceoCardsInHand, (card) => {
                                    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                                        key: card.name,
                                        class: "cardbox"
                                    }, [
                                        (0, vue_1.createVNode)(_component_Card, { card: card }, null, 8, ["card"])
                                    ]));
                                }), 128))
                                : (0, vue_1.createCommentVNode)("", true)
                        ]),
                        (0, vue_1.createElementVNode)("div", null, [
                            ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.playerView.cardsInHand, (card) => {
                                return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                                    key: card.name,
                                    class: "cardbox"
                                }, [
                                    (0, vue_1.createVNode)(_component_Card, { card: card }, null, 8, ["card"])
                                ]));
                            }), 128))
                        ])
                    ], 64))
                    : (0, vue_1.createCommentVNode)("", true),
                (_ctx.playerView.pickedCorporationCard.length === 0)
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_dynamic_title, {
                        key: 3,
                        title: "Select initial cards:",
                        color: _ctx.thisPlayer.color
                    }, null, 8, ["color"]))
                    : (0, vue_1.createCommentVNode)("", true),
                (_ctx.game.phase !== 'end')
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_waiting_for, {
                        key: 4,
                        players: _ctx.playerView.players,
                        playerView: _ctx.playerView,
                        settings: _ctx.settings,
                        waitingfor: _ctx.playerView.waitingFor
                    }, null, 8, ["players", "playerView", "settings", "waitingfor"]))
                    : (0, vue_1.createCommentVNode)("", true),
                (0, vue_1.createVNode)(_component_dynamic_title, {
                    title: "Game details",
                    color: _ctx.thisPlayer.color
                }, null, 8, ["color"]),
                (_ctx.playerView.players.length > 1)
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_37, [
                        (0, vue_1.createVNode)(_component_Milestones, {
                            showScores: false,
                            milestones: _ctx.game.milestones
                        }, null, 8, ["milestones"]),
                        (0, vue_1.createVNode)(_component_Awards, {
                            awards: _ctx.game.awards
                        }, null, 8, ["awards"])
                    ]))
                    : (0, vue_1.createCommentVNode)("", true),
                (_ctx.playerView.players.length > 1)
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_38, [
                        (0, vue_1.createVNode)(_component_dynamic_title, {
                            title: "Turn order",
                            color: _ctx.thisPlayer.color
                        }, null, 8, ["color"]),
                        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.playerView.players, (p, idx) => {
                            return (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                                class: "player_item",
                                key: idx
                            }, [
                                (0, vue_1.createElementVNode)("div", {
                                    class: (0, vue_1.normalizeClass)(["player_name_cont", _ctx.getPlayerCssForTurnOrder(p, true)])
                                }, [
                                    (0, vue_1.createElementVNode)("span", _hoisted_39, (0, vue_1.toDisplayString)(idx + 1) + ".", 1),
                                    (0, vue_1.createElementVNode)("span", {
                                        class: (0, vue_1.normalizeClass)(["player_name", _ctx.getPlayerCssForTurnOrder(p, false)]),
                                        href: "#"
                                    }, (0, vue_1.toDisplayString)(p.name), 3)
                                ], 2),
                                (idx !== _ctx.playerView.players.length - 1)
                                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_40, "⟶"))
                                    : (0, vue_1.createCommentVNode)("", true)
                            ])), [
                                [_directive_trim_whitespace]
                            ]);
                        }), 128))
                    ]))
                    : (0, vue_1.createCommentVNode)("", true),
                (0, vue_1.createElementVNode)("details", _hoisted_41, [
                    (0, vue_1.createElementVNode)("summary", _hoisted_42, [
                        (0, vue_1.createElementVNode)("div", _hoisted_43, [
                            _cache[28] || (_cache[28] = (0, vue_1.createElementVNode)("i", { class: "icon icon-arrow-right mr-1" }, null, -1)),
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[27] || (_cache[27] = [
                                    (0, vue_1.createTextVNode)("Board", -1)
                                ]))])), [
                                [_directive_i18n]
                            ])
                        ])
                    ]),
                    (0, vue_1.createElementVNode)("div", _hoisted_44, [
                        (0, vue_1.createVNode)(_component_board, {
                            spaces: _ctx.game.spaces,
                            expansions: _ctx.game.gameOptions.expansions,
                            venusScaleLevel: _ctx.game.venusScaleLevel,
                            boardName: _ctx.game.gameOptions.boardName,
                            aresData: _ctx.game.aresData,
                            altVenusBoard: _ctx.game.gameOptions.altVenusBoard
                        }, null, 8, ["spaces", "expansions", "venusScaleLevel", "boardName", "aresData", "altVenusBoard"]),
                        (_ctx.game.turmoil)
                            ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_turmoil, {
                                key: 0,
                                turmoil: _ctx.game.turmoil
                            }, null, 8, ["turmoil"]))
                            : (0, vue_1.createCommentVNode)("", true),
                        _cache[29] || (_cache[29] = (0, vue_1.createElementVNode)("a", {
                            name: "moonBoard",
                            class: "player_home_anchor"
                        }, null, -1)),
                        (_ctx.game.moon !== undefined)
                            ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_MoonBoard, {
                                key: 1,
                                model: _ctx.game.moon,
                                tileView: _ctx.tileView
                            }, null, 8, ["model", "tileView"]))
                            : (0, vue_1.createCommentVNode)("", true)
                    ])
                ]),
                (_ctx.game.colonies.length > 0)
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_45, [
                        (0, vue_1.createVNode)(_component_dynamic_title, {
                            title: "Colonies",
                            color: _ctx.thisPlayer.color
                        }, null, 8, ["color"]),
                        (0, vue_1.createElementVNode)("div", _hoisted_46, [
                            ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.game.colonies, (colony) => {
                                return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                                    class: "player_home_colony",
                                    key: colony.name
                                }, [
                                    (0, vue_1.createVNode)(_component_colony, {
                                        colony: colony,
                                        active: colony.isActive
                                    }, null, 8, ["colony", "active"])
                                ]));
                            }), 128))
                        ])
                    ]))
                    : (0, vue_1.createCommentVNode)("", true)
            ]))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.game.spectatorId && (_ctx.activeTab === 'board' || _ctx.isInSetupPhase))
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_47, [
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                    href: '/spectator?id=' + _ctx.game.spectatorId,
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, [...(_cache[30] || (_cache[30] = [
                        (0, vue_1.createTextVNode)("Spectator link", -1)
                    ]))], 8, _hoisted_48)), [
                    [_directive_i18n]
                ])
            ]))
            : (0, vue_1.createCommentVNode)("", true),
        (0, vue_1.withDirectives)((0, vue_1.createVNode)(_component_purge_warning, {
            expectedPurgeTimeMs: _ctx.playerView.game.expectedPurgeTimeMs
        }, null, 8, ["expectedPurgeTimeMs"]), [
            [vue_1.vShow, _ctx.activeTab === 'board' || _ctx.isInSetupPhase]
        ]),
        (0, vue_1.withDirectives)((0, vue_1.createVNode)(_component_KeyboardShortcuts, {
            onClose: _cache[9] || (_cache[9] = ($event) => (_ctx.keyboardShortcutOpened = false))
        }, null, 512), [
            [vue_1.vShow, _ctx.keyboardShortcutOpened]
        ])
    ], 2));
}
